import { DateFormat, formatDate, now } from "common";
import { Dayjs } from "dayjs";
import create from "zustand";
import { CreatedAtRangeProps, DateFilterRange } from "./analyticsFilterStore";

interface PayoutFilterState {
    to?: Dayjs;
    from?: Dayjs;
    getFrom: () => Dayjs;
    getTo: () => Dayjs;
    setFrom: (date: Dayjs) => void;
    setTo: (date: Dayjs) => void;
    getDateParams: () => CreatedAtRangeProps;
}

export const defaultPayoutDateRange = () => {
    return { from: now().subtract(7, "days").startOf("day"), to: now().endOf("day") };
};

export const usePayoutFilterStore = create<PayoutFilterState>((set, get) => ({
    to: undefined,
    from: undefined,

    getDateParams() {
        const from = get().getFrom();
        const to = get().getTo();
        const params = [formatDate(from, DateFormat.DATE_TIME_ISO), formatDate(to, DateFormat.DATE_TIME_ISO)];
        return { [DateFilterRange.CREATED_AT]: params.join(",") };
    },

    getFrom() {
        return get().from ?? defaultPayoutDateRange().from;
    },

    getTo() {
        return get().to ?? defaultPayoutDateRange().to;
    },

    setFrom(from: Dayjs) {
        set(() => ({ from: from.startOf("day") }));
    },

    setTo(to: Dayjs) {
        set(() => ({ to: to.endOf("day") }));
    },
}));
